import { Card, Select, TextField } from "@mui/material";
import "./BasicInformation.scss";
import { Field, Formik } from "formik";
import * as yup from "yup";
import { useEffect, useMemo, useRef, useState } from "react";
import { GoogleMap, Marker, MarkerF, useLoadScript, useJsApiLoader, Autocomplete } from "@react-google-maps/api";
import {
  API_RESPONSE,
  COMMON_CONSTANTS,
  I18_TRANSLATION_COMMON,
  MODES,
  NUMBER_CONSTANTS,
  REGISTRATION_FORM,
  ROUTES,
  STORAGE_KEYS,
  TOASTER_CONFIGS,
  TOKENS,
} from "../../../../Utilities/Constants/Constants";
import { useTranslation } from "react-i18next";
import {
  ERROR_MESSAGES,
  REGEX,
  REGISTRATION_ERRORS,
} from "../../../../Utilities/Constants/Validations";
import { MenuItem } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { format } from "date-fns";
import { REGISTRATION_MODEL } from "../../../../Utilities/Models/ConstantModels";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from "libphonenumber-js";
import { axiosInstance } from "../../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../../Utilities/Constants/ApiEndpoints";
import { GetSessionStorageData, SetSessionStorageData, numberOnly } from "../../../../Services/Helpers/Helper";
import { toast } from "react-toastify";
// import Autocomplete from "react-google-autocomplete";
import RoomIcon from '@mui/icons-material/Room';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import { useLocation } from "react-router-dom";

const libraries: any = ['places'];
const BasicInformation = (props: any) => {
  const { isLoaded }: any = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY || '',
    libraries
  });
  const geocoder: any = isLoaded ? new window.google.maps.Geocoder() : '';
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [mode, setMode] = useState(MODES.EDIT);
  const [userType, setuserType]: any = useState("");
  const [currentGender, setCurrentGender] = useState("");
  const [phoneNumber, setPhoneNumber]: any = useState("");
  const [validPhoneNumber, setValidPhoneNumber] = useState(API_RESPONSE.TRUE);
  const [loginType, setLoginType]: any = useState("");
  const [initialRender, setInitialRender] = useState(API_RESPONSE.TRUE);
  const [basicInformation, setBasicInformation]: any = useState({});
  const [aboutMeField, setAboutMeField] = useState("");
  const [currentLocation, setCurrentLocation]: any = useState();
  const [EmiratesList, setEmiratesList]: any = useState<any>([]);
  const [mapEnabled, setMapEnabled] = useState(API_RESPONSE.TRUE);
  const [editable, setEditable] = useState(API_RESPONSE.TRUE);
  const [autocomplete, setAutocomplete] = useState<any>(null);
  const inputRef = useRef<any>(null);
  const location = useLocation();
  const URL_VALIDATION = new RegExp("((https?):\\/\\/)?(www\\.)?[a-z0-9-]+(\\.[a-z]{2,}){1,3}(\\:[0-9]{1,5})?(\/[-a-zA-Z0-9@:%._\+~#=]*)*?(\\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$");

  let validationSchema = {
    firstname: yup
      .string()
      .min(NUMBER_CONSTANTS.ONE)
      .required(REGISTRATION_ERRORS.FIRST_NAME)
      .trim(),
    lastname: yup
      .string()
      .min(NUMBER_CONSTANTS.ONE)
      .required(REGISTRATION_ERRORS.LAST_NAME)
      .trim(),
    email: yup
      .string()
      .required(ERROR_MESSAGES.EMAIL_REQUIRED)
      // .matches(REGEX.EMAIL, ERROR_MESSAGES.INVALID_EMAIL)
      .email(ERROR_MESSAGES.INVALID_EMAIL),
    phone_number: yup.string().required(ERROR_MESSAGES.PHONE_NUMBER),
    [aboutMeField]: yup.string().nullable().required(userType === `${NUMBER_CONSTANTS.FIVE}` ? REGISTRATION_ERRORS.ABOUT_CAMP : REGISTRATION_ERRORS.ABOUT_ME),
    gender: userType === `${NUMBER_CONSTANTS.FIVE}` ? yup.string().nullable() : yup.string().required(REGISTRATION_ERRORS.GENDER_ERR),
    // nationality: yup.string().required(REGISTRATION_ERRORS.NATIONALITY),
    address: yup.string().required(REGISTRATION_ERRORS.ADDRESS),
    city: yup.string().required(REGISTRATION_ERRORS.CITY),
    emirate: yup.string().required(REGISTRATION_ERRORS.EMIRATE),
    description: yup.string().required(REGISTRATION_ERRORS.DISCRIPTION),
    // state: yup.string().required(REGISTRATION_ERRORS.STATE),
    // pincode: yup.string()/* .required(REGISTRATION_ERRORS.PINCODE) */,
    dob: userType === `${NUMBER_CONSTANTS.FIVE}` ? yup.string().nullable() : yup.string().required(REGISTRATION_ERRORS.DOB),
    country: yup.string().required(REGISTRATION_ERRORS.COUNTRY),
    country_code: yup.string().required(REGISTRATION_ERRORS.COUNTRY_CODE),

    // website_name: yup
    //   .string()
    //   .matches(URL_VALIDATION,REGISTRATION_ERRORS.CAMPSITE)
    //   // .matches("((https?):\\/\\/)?(www\\.)?[a-z0-9-]+(\\.[a-z]{2,}){1,3}(\\:[0-9]{1,5})?(\/[-a-zA-Z0-9@:%._\+~#=]*)*?(\\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$")

    //   //   URL_VALIDATION: new RegExp(
    //   //     "((https?):\\/\\/)?(www\\.)?[a-z0-9-]+(\\.[a-z]{2,}){1,3}(\\:[0-9]{1,5})?(\/[-a-zA-Z0-9@:%._\+~#=]*)*?(\\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$"
    //   //   ),
    //   // .matches(REGEX.URL_VALIDATION, EDIT_UNIVERSITY_ERROR_MESSAGE.VALID_URL)
    //   .required(REGISTRATION_ERRORS.CAMPSITE),

  }
  const [initialValue, setInitialValue]: any = useState({
    [REGISTRATION_FORM.FIRST_NAME]: "",
    [REGISTRATION_FORM.FIRST_NAME_ARABIC]: "",
    [REGISTRATION_FORM.LAST_NAME]: "",
    [REGISTRATION_FORM.LAST_NAME_ARABIC]: "",
    [REGISTRATION_FORM.CAMP_NAME]: "",
    [REGISTRATION_FORM.CAMP_NAME_ARABIC]: "",
    email: GetSessionStorageData(STORAGE_KEYS.EMAIL) || "",
    phone_number: GetSessionStorageData(STORAGE_KEYS.PHONE_NUMBER) || "",
    about_me: "",
    description: "",
    gender: "",
    nationality: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    dob: "",
    country: "",
    country_code: "",
    latitude: "",
    longitude: "",
    about_camp: "",
    emirate: "",
    website_name: "",
  });

  useEffect(() => {
    setuserType(GetSessionStorageData(STORAGE_KEYS.ROLE));
    getEmiratesList();

  }, []);

  const checkString = (data: any) => {

    // Convert array to a string
    var dataAsString = JSON.stringify(data);

    // Check if the string contains square brackets
    if (dataAsString?.includes('[') && dataAsString?.includes(']')) {
      const match = data?.match(/\['([^']+)'\]/);
      return match ? match[1] : null;
    } else {
      return data;
    }
  }


  // useEffect(() => {
  //   // Get current user's location using the browser's Geolocation API
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const { latitude, longitude } = position.coords;
  //         setCurrentLocation({ lat: latitude, lng: longitude });
  //       },
  //     );
  //   }
  // }, [])

  useEffect(() => {
    defineApiPoints();
  }, [userType]);

  const defineApiPoints = () => {
    if (userType == `${NUMBER_CONSTANTS.FIVE}`) {
      setAboutMeField(REGISTRATION_FORM.ABOUT_CAMP);
      // validationSchema.campname = yup.string().required(REGISTRATION_ERRORS.CAMP_NAME);
      getRegistrationDetail(API_END_POINTS.GET_CAMP_DETAILS)
    } else if (userType == `${NUMBER_CONSTANTS.NINE}`) {
      setAboutMeField(REGISTRATION_FORM.ABOUT_ME);
      getRegistrationDetail(API_END_POINTS.GET_PERSONAL_DETAILS)
    } else if (userType == `${NUMBER_CONSTANTS.FOUR}`) {
      setAboutMeField(REGISTRATION_FORM.ABOUT_ME);
      getRegistrationDetail(API_END_POINTS.GET_SPDETAILS);
    } else if (userType == `${NUMBER_CONSTANTS.THREE}`) {
      setAboutMeField(REGISTRATION_FORM.ABOUT_ME);
      getRegistrationDetail(API_END_POINTS.GET_SPDETAILS);
    }
  }


  const getEmiratesList = () => {
    axiosInstance.get(API_END_POINTS.EMIRATE_LIST).then((response) => {
      setEmiratesList(response?.data?.result?.data)
    }).catch(() => { })
  }

  useEffect(() => {
  }, [editable])
  const getRegistrationDetail = (END_POINTS: any) => {

    if (GetSessionStorageData(TOKENS.TEMPORARY_TOKEN) || location.pathname === ROUTES.PROFILE) {
      axiosInstance.get(END_POINTS).then((response) => {
        if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
          setBasicInformation(response.data.result.data[NUMBER_CONSTANTS.ZERO]);
          let data = response.data.result.data[NUMBER_CONSTANTS.ZERO];
          setEditable((prev) => data?.status === "approved" ? API_RESPONSE.FALSE : API_RESPONSE.TRUE);
          setInitialValue({
            [REGISTRATION_FORM.FIRST_NAME]: data.profile_details.firstname,
            lastname: data.profile_details.lastname,
            email: data?.profile_details?.email,
            arabic_firstname: data?.profile_details?.arabic_firstname,
            arabic_lastname: data?.profile_details?.arabic_lastname,
            phone_number: data.profile_details.phone_number,
            about_me: Array.isArray(data?.about_me) ? data.about_me[0] : data?.about_me || "",
            gender: data.gender,
            nationality: data.nationality,
            address: data.address ? data.address : "",
            description: data?.description ? data?.description : "",
            city: data.city,
            emirate: data.emirate,
            state: data.state,
            pincode: data.pincode,
            dob: data.dob,
            country: data.country,
            country_code: data.country_code,
            latitude: data.latitude,
            longitude: data.longitude,
            campname: data.campname,
            about_camp: data?.about_camp ? data?.about_camp : "",
            website_name: data?.website_name ? data?.website_name : ""

          });
          setPhoneNumber(data.profile_details.phone_number)
          setCurrentGender(data.gender)
          setCurrentLocation({ lat: parseFloat(data?.latitude), lng: parseFloat(data?.longitude) });
        }
      })
    }

  }

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      setLoginType(GetSessionStorageData(STORAGE_KEYS.LOGIN_TYPE));
    }
    setLoginType(GetSessionStorageData(STORAGE_KEYS.LOGIN_TYPE));
  }, []);

  useEffect(() => {
    /* if (loginType === `${NUMBER_CONSTANTS.ONE}`) {
      initialValue.email = GetSessionStorageData(STORAGE_KEYS.EMAIL)
      console.log(initialValue,'init value',GetSessionStorageData(STORAGE_KEYS.EMAIL))
    } else {
      initialValue.phone_number = GetSessionStorageData(STORAGE_KEYS.PHONE_NUMBER);
      setPhoneNumber(GetSessionStorageData(STORAGE_KEYS.PHONE_NUMBER) || '');
    }; */
  }, [loginType])


  useEffect(() => {
    props.currentMode ? setMode(props.currentMode) : setMode(MODES.EDIT);
  }, []);



  /* yup validation schema */
  const formValidationSchema = yup.object(validationSchema);

  /* Validate phone number */
  const validatePhoneNumber = (e: any) => {
    // isValidPhoneNumber(e);
    isValidPhoneNumber(e) === API_RESPONSE.TRUE
      ? setValidPhoneNumber(API_RESPONSE.TRUE)
      : setValidPhoneNumber(API_RESPONSE.FALSE);
    return isValidPhoneNumber(e);
  };

  /* Navigate call */
  const onNavigate = (state: any) => {
    props.activeStatus(state);
  };

  /* Update gender state */
  const onSelectGender = (event: any) => {
    setCurrentGender(event.target.value);
  };

  /* Handling tokens */
  const responseAction = (response: any) => {
    return new Promise((resolve, reject) => {
      if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
        SetSessionStorageData(
          TOKENS.TEMPORARY_TOKEN,
          response.data.result.data.access_token
        );
        SetSessionStorageData(
          TOKENS.REFRESH_TOKEN,
          response.data.result.data.refresh_token
        );
        //navigate(ROUTES.DASHBOARD);
        toast.success(response.data.message, TOASTER_CONFIGS);
        resolve(API_RESPONSE.TRUE);
      }
    })
  };

  const onRegister = (payload: any, API: any) => {
    if (basicInformation && GetSessionStorageData(TOKENS.TEMPORARY_TOKEN) || location.pathname === ROUTES.PROFILE) {
      axiosInstance
        .put(API, payload)
        .then((response: any) => {
          if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            responseAction(response);
            if (location.pathname !== ROUTES.PROFILE)
              onNavigate(NUMBER_CONSTANTS.TWO);
          }
        }).catch(() => { });
    } else {
      axiosInstance
        .post(API, payload)
        .then((response: any) => {
          if (response.data[API_RESPONSE.STATUS] === API_RESPONSE.TRUE) {
            responseAction(response);
            onNavigate(NUMBER_CONSTANTS.TWO);
          }
        }).catch(() => { });
    }

  };

  const setCurrentLatLng = (latitude: any, longitude: any) => {
    setCurrentLocation({ lat: latitude, lng: longitude });
  }

  const setAddressData = (address: any, formik: any) => {
    formik.setFieldValue(REGISTRATION_FORM.CITY, "");
    formik.setFieldValue(REGISTRATION_FORM.STATE, "");
    formik.setFieldValue(REGISTRATION_FORM.COUNTRY, "");
    formik.setFieldValue(REGISTRATION_FORM.PINCODE, "");
    address.forEach((component: any) => {
      const componentType = component.types[0];

      switch (componentType) {
        // case 'locality':
        case 'administrative_area_level_3':
          formik.setFieldValue(REGISTRATION_FORM.CITY, component.long_name)
          break;
        case 'administrative_area_level_1':
          formik.setFieldValue(REGISTRATION_FORM.STATE, component.long_name)
          break;
        case 'country':
          formik.setFieldValue(REGISTRATION_FORM.COUNTRY, component.long_name)
          break;

        case 'postal_code':
        case 'postal_code_prefix':
          formik.setFieldValue(REGISTRATION_FORM.PINCODE, component.long_name)
          break;
        default:
          break;
      };
    });
  }

  const getFormattedAddress = (lat: any, lng: any, formik: any, check: boolean) => {
    geocoder.geocode({ location: { lat, lng } }, (results: any, status: any) => {
      if (status === "OK") {
        if (results[NUMBER_CONSTANTS.ZERO]) {
          let filterCountry = results[0]?.address_components?.filter((res: any) => {
            return res.types[NUMBER_CONSTANTS.ZERO] === 'country'
          });
          if (results[NUMBER_CONSTANTS.ZERO]) {
            if (check) {
              formik.setFieldValue(
                REGISTRATION_FORM.COUNTRY,
                results[NUMBER_CONSTANTS.ZERO].formatted_address
              )
            }
            formik.setFieldValue(
              REGISTRATION_FORM.COUNTRY,
              filterCountry[NUMBER_CONSTANTS.ZERO]?.long_name ? filterCountry[0]?.long_name : "N/A"
            )
          }
        }
      }
    });
  }


  /* Submit API call */
  const onSaveBasicInformation = (payload: any) => {
    console.log("🚀 ~ onSaveBasicInformation ~ payload:", payload)
    if (validatePhoneNumber(phoneNumber?.split("+").length > 1 ? phoneNumber : "+" + phoneNumber)) {
      payload.roles = GetSessionStorageData(STORAGE_KEYS.ROLE);
      payload.id = GetSessionStorageData(STORAGE_KEYS.ID);
      payload.latitude = `${currentLocation.lat ? currentLocation.lat : ''}`;
      payload.longitude = `${currentLocation.lng ? currentLocation.lng : ''}`;
      payload.state = payload.emirate
      if (userType === `${NUMBER_CONSTANTS.FOUR}`) {
        onRegister(payload, API_END_POINTS.BASIC_INFORMATION);
      } else if (userType === `${NUMBER_CONSTANTS.NINE}`) {
        onRegister(payload, API_END_POINTS.PERSONAL_BASIC_REGISTER);
      } else if (userType === `${NUMBER_CONSTANTS.FIVE}`) {
        onRegister(payload, API_END_POINTS.CAMP_BASIC_REGISTER)
      } else if (userType === `${NUMBER_CONSTANTS.THREE}`) {
        onRegister(payload, API_END_POINTS.EXPERTS_BASIC_REGISTER)
      }
    }


  };

  const onReset = () => {
    defineApiPoints();
  }

  const currentDate = new Date();
  const AgeRestriction = new Date();
  AgeRestriction.setFullYear(currentDate.getFullYear() - 16);

  const onPlaceChanged = (formik: any) => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        const location = place?.geometry?.location;
        const lat = location.lat();
        const lng = location.lng();
        setCurrentLatLng(lat, lng);
        getFormattedAddress(lat, lng, formik, false);
        if (inputRef?.current) {
          const inputValue = inputRef.current.value;
          formik.setFieldValue(REGISTRATION_FORM.ADDRESS, inputValue);
        }
      }
    }
  };

  const onAutocompleteLoad = (autoC: any) => {
    setAutocomplete(autoC); // Save the autocomplete instance
  };

  return (
    <div className="row bi-wrapper">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <Card
          className={
            mode === MODES.VIEW ? "bi-card-wrapper-view" : "bi-card-wrapper"
          }
        >
          <Formik
            initialValues={initialValue}
            enableReinitialize={true}
            validationSchema={formValidationSchema}
            onSubmit={(values, actions) => {
              onSaveBasicInformation(values);
            }}
          >
            {(formik: any) => {
              return (
                <div>
                  <h4 className="header-title">Basic Information</h4>
                  {userType === `${NUMBER_CONSTANTS.FIVE}` && <div className="row">
                    <div className="col-md-12">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("Camp Name")}</label>
                        <Field
                          name={REGISTRATION_FORM.CAMP_NAME}
                          className="email-input"
                          placeholder={t(`Camp Name`)}
                          disabled={editable ? false : true}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.CAMP_NAME] &&
                            formik.errors[REGISTRATION_FORM.CAMP_NAME] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.CAMP_NAME]}`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>}

                  {userType === `${NUMBER_CONSTANTS.FIVE}` && <div className="row">
                    <div className="col-md-12">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("Camp Name Arabic")}</label>
                        <Field
                          name={REGISTRATION_FORM.CAMP_NAME_ARABIC}
                          className="email-input"
                          placeholder={t(`Camp Name In Arabic`)}
                          disabled={editable ? false : true}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.CAMP_NAME_ARABIC] &&
                            formik.errors[REGISTRATION_FORM.CAMP_NAME_ARABIC] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.CAMP_NAME_ARABIC]}`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>}

                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t(userType === `${NUMBER_CONSTANTS.FIVE}` ? "Applicant First Name" : "First name")}</label>
                        <Field
                          name={REGISTRATION_FORM.FIRST_NAME}
                          className="email-input"
                          placeholder={t("First name")}
                          disabled={editable ? false : true}

                          min={3}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.FIRST_NAME] &&
                            formik.errors[REGISTRATION_FORM.FIRST_NAME] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.FIRST_NAME]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t(userType === `${NUMBER_CONSTANTS.FIVE}` ? "Applicant Last Name" : "Last name")}</label>
                        <Field
                          name={REGISTRATION_FORM.LAST_NAME}
                          className="email-input"
                          placeholder={t("Last name")}
                          disabled={editable ? false : true}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.LAST_NAME] &&
                            formik.errors[REGISTRATION_FORM.LAST_NAME] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.LAST_NAME]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {userType !== `${NUMBER_CONSTANTS.FIVE}` && <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("First name in Arabic")}</label>
                        <Field
                          name={REGISTRATION_FORM.FIRST_NAME_ARABIC}
                          className="email-input"
                          placeholder={t("First name In Arabic")}
                          disabled={editable ? false : true}

                          min={3}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.FIRST_NAME_ARABIC] &&
                            formik.errors[REGISTRATION_FORM.FIRST_NAME_ARABIC] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.FIRST_NAME_ARABIC]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("Last name In Arabic")}</label>
                        <Field
                          name={REGISTRATION_FORM.LAST_NAME_ARABIC}
                          className="email-input"
                          placeholder={t("Last name In Arabic")}
                          disabled={editable ? false : true}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.LAST_NAME_ARABIC] &&
                            formik.errors[REGISTRATION_FORM.LAST_NAME_ARABIC] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.LAST_NAME_ARABIC]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>}


                  <div className="row row-wrap">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="form-items">
                        <label className="form-label mandatory">{userType === `${NUMBER_CONSTANTS.FIVE}` ? t("About Camp") : t("About me")}</label>
                        <Field
                          as="textarea"
                          name={aboutMeField}
                          className="email-input input-textarea"
                          /*  onKeyPress={(event: any) => {
                             if (200 - formik.values[aboutMeField].length <= 0)
                               event?.preventDefault();
                           }} */
                          maxlength={500}
                          onChange={(event: any) => {
                            formik.setFieldValue(aboutMeField, event.target.value)
                          }}
                          placeholder={userType === `${NUMBER_CONSTANTS.FIVE}` ? t("About Camp") : t("About me")}
                          disabled={editable ? false : true}
                        />
                        <p className="characters-left">

                          You have {200 - formik.values[aboutMeField]?.length}{" "} characters left

                        </p>
                        <div className="errorMessage">
                          {formik.touched[aboutMeField] &&
                            formik.errors[aboutMeField] && (
                              <p>
                                {t(
                                  `${formik.errors[aboutMeField]}`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row row-wrap">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("Description")}</label>
                        <Field
                          as="textarea"
                          name={REGISTRATION_FORM.DISCRIPTION}
                          className="email-input input-textarea"
                          maxLength={250}
                          /* onKeyPress={(event: any) => {
                            if (160 - formik?.values[REGISTRATION_FORM.DISCRIPTION]?.length <= 0)
                              event?.preventDefault();
                          }} */
                          onChange={(event: any) => {
                            formik.setFieldValue(REGISTRATION_FORM.DISCRIPTION, event.target.value)
                          }}
                          placeholder={t("Description")}
                          disabled={editable ? false : true}
                        />
                        <p className="characters-left">

                          You have {160 - /* formik?.values[REGISTRATION_FORM.DISCRIPTION] ?  */formik.values[REGISTRATION_FORM.DISCRIPTION]?.length /* : "" */}{" "} characters left

                        </p>
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.DISCRIPTION] &&
                            formik.errors[REGISTRATION_FORM.DISCRIPTION] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.DISCRIPTION]}`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t(userType === `${NUMBER_CONSTANTS.FIVE}` ? "Camp Email" : "Email")}</label>
                        <Field
                          name={REGISTRATION_FORM.EMAIL}
                          className="email-input"
                          placeholder={t("Email")}
                          value={GetSessionStorageData(STORAGE_KEYS.EMAIL) || ""}
                          //  disabled={editable ? false : true}
                          disabled={loginType === `${NUMBER_CONSTANTS.ONE}` ? true : false}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.EMAIL] &&
                            formik.errors[REGISTRATION_FORM.EMAIL] ? (
                            <p>
                              {t(`${formik.errors[REGISTRATION_FORM.EMAIL]}`)}
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">
                          {t(userType === `${NUMBER_CONSTANTS.FIVE}` ? "Camp Phone Number" : "Phone Number")}
                        </label>
                        <PhoneInput
                          inputProps={{
                            className: "input phone_num_input",
                          }}
                          country={"ae"}
                          enableSearch={true}
                          value={phoneNumber}
                          disabled={(loginType === `${NUMBER_CONSTANTS.ZERO}` ? true : false) || (editable ? false : true)}
                          onChange={(e: any, country: any) => {

                            setPhoneNumber(e);
                            validatePhoneNumber("+" + e);
                            formik.setFieldValue(
                              REGISTRATION_FORM.PHONE_NUMBER,
                              "+" + e
                            );
                            formik.setFieldValue(
                              REGISTRATION_FORM.COUNTRY_CODE,
                              "+" + country.dialCode
                            )
                          }}
                          countryCodeEditable={false}
                          placeholder="Enter your phone number"
                        />
                        <p className="mb-0 phone-validation">{COMMON_CONSTANTS.PHONE_FORMAT}</p>
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.PHONE_NUMBER] &&
                            validPhoneNumber === false && (
                              <p>
                                {t(
                                  `${ERROR_MESSAGES.PHONE_NUMBER
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {userType !== `${NUMBER_CONSTANTS.FIVE}` && <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("DOB")}</label>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            className="email-input"
                            openTo="year"
                            views={["year", "month", "day"]}
                            value={
                              new Date(formik.values[REGISTRATION_FORM.DOB])
                            }
                            maxDate={new Date()}
                            disabled={editable ? false : true}
                            slotProps={{
                              textField: {
                                size: "medium",
                                error: false,
                              },
                            }}
                            onChange={(date) => {
                              const formattedDate = date
                                ? format(date, "yyyy-MM-dd")
                                : "";
                              formik.setFieldValue(
                                REGISTRATION_FORM.DOB,
                                formattedDate
                              );
                            }}
                          />
                        </LocalizationProvider>
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.DOB] &&
                            formik.errors[REGISTRATION_FORM.DOB] && (
                              <p>
                                {t(`${formik.errors[REGISTRATION_FORM.DOB]}`)}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("Gender")}</label>
                        <Field
                          as="select"
                          name={REGISTRATION_FORM.GENDER}
                          disabled={editable ? false : true}
                          className="email-input"
                          onChange={(e: any) => {
                            onSelectGender(e);
                            formik.setFieldValue(
                              REGISTRATION_FORM.GENDER,
                              e.target.value
                            );
                          }}
                          value={currentGender}
                        >
                          <option value="">Please select gender</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                          <option value="others">Others</option>
                        </Field>
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.GENDER] &&
                            formik.errors[REGISTRATION_FORM.GENDER] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.GENDER]}`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>}
                  <div className="row row-wrap">

                    <div className="col-md-12">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("Address")}</label>

                        <div className="address-wrapper">
                          {isLoaded &&
                            // <Autocomplete
                            //   disabled={editable ? false : true}
                            //   apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                            //   value={formik.values[REGISTRATION_FORM.ADDRESS]}
                            //   onBlur={formik.handleBlur}
                            //   onChange={(e: any) => {
                            //     formik.setFieldValue(REGISTRATION_FORM.ADDRESS, e.target.value)
                            //   }}
                            //   onPlaceSelected={(place: any) => {
                            //     setCurrentLatLng(place.geometry.location.lat(), place.geometry.location.lng());
                            //     getFormattedAddress(place.geometry.location.lat(), place.geometry.location.lng(), formik);
                            //   }}
                            // />
                            <Autocomplete onLoad={onAutocompleteLoad} onPlaceChanged={() => onPlaceChanged(formik)}>
                              <input
                                type="text"
                                className="auto-complete"
                                name={REGISTRATION_FORM.ADDRESS}
                                ref={inputRef} // Attach the ref here
                                // disabled={editable ? false : true}
                                placeholder="Enter a place"
                                value={formik.values[REGISTRATION_FORM.ADDRESS]} // Bind formik value
                                onChange={formik.handleChange}
                              />
                            </Autocomplete>
                          }
                          {mapEnabled && <RoomIcon className="room-icon" onClick={() => { setMapEnabled(!mapEnabled) }} />}
                          {!mapEnabled && <LocationOffIcon className="room-icon" onClick={() => { setMapEnabled(!mapEnabled) }} />}
                        </div>

                        {isLoaded && mapEnabled && <GoogleMap
                          mapContainerClassName="map-container"
                          center={currentLocation}
                          zoom={10}
                        >
                          {<MarkerF
                            position={currentLocation}
                            draggable={true}
                            onDragEnd={
                              (e: any) => {
                                if (editable) {
                                  setCurrentLatLng(e.latLng.lat(), e.latLng.lng());
                                  getFormattedAddress(e.latLng.lat(), e.latLng.lng(), formik, true);
                                }
                              }}
                          />}
                        </GoogleMap>}
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.ADDRESS] &&
                            formik.errors[REGISTRATION_FORM.ADDRESS] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.ADDRESS]}`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("States/Emirates")}</label>
                        <Field
                          as="select"
                          name={REGISTRATION_FORM.EMIRATE}
                          disabled={editable ? false : true}
                          className="email-input"
                          onChange={(e: any) => {
                            formik.setFieldValue(
                              REGISTRATION_FORM.EMIRATE,
                              e.target.value
                            );
                          }}
                        >
                          <option value="">Please select emirate</option>
                          {EmiratesList?.map((item: any) => {
                            return (
                              <option value={item.emirate_city}>{item.emirate_city}</option>
                            )
                          })}
                        </Field>
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.EMIRATE] &&
                            formik.errors[REGISTRATION_FORM.EMIRATE] && (
                              <p>
                                {t(`${formik.errors[REGISTRATION_FORM.EMIRATE]}`)}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("City")}</label>
                        <Field
                          as="select"
                          name={REGISTRATION_FORM.CITY}
                          disabled={editable ? false : true}
                          className="email-input"
                          onChange={(e: any) => {
                            formik.setFieldValue(
                              REGISTRATION_FORM.CITY,
                              e.target.value
                            );
                          }}
                        >
                          <option value="">Please select city</option>
                          {EmiratesList?.map((item: any) => {
                            return (
                              <option value={item.emirate_city}>{item.emirate_city}</option>
                            )
                          })}
                        </Field>
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.CITY] &&
                            formik.errors[REGISTRATION_FORM.CITY] && (
                              <p>
                                {t(`${formik.errors[REGISTRATION_FORM.CITY]}`)}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row row-wrap">
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">{t("PO Code")}</label>
                        <Field
                          name={REGISTRATION_FORM.PINCODE}
                          className="email-input"
                          placeholder={t("Ex: 500001")}
                          onInput={numberOnly}
                          onPaste={numberOnly}
                          maxLength={6}
                          disabled={editable ? false : true}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.PINCODE] &&
                            formik.errors[REGISTRATION_FORM.PINCODE] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.PINCODE]}`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("State")}</label>
                        <Field
                          name={REGISTRATION_FORM.STATE}
                          className="email-input"
                          placeholder={t("State")}
                           disabled={editable ? false : true}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.STATE] &&
                            formik.errors[REGISTRATION_FORM.STATE] && (
                              <p>
                                {t(`${formik.errors[REGISTRATION_FORM.STATE]}`)}
                              </p>
                            )}
                        </div>
                      </div>
                    </div> */}
                    <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("Country")}</label>
                        <Field
                          name={REGISTRATION_FORM.COUNTRY}
                          className="email-input"
                          placeholder={t(`Country`)}
                          value={formik.values[REGISTRATION_FORM.COUNTRY]}
                          disabled
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.COUNTRY] &&
                            formik.errors[REGISTRATION_FORM.COUNTRY] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.COUNTRY]}`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>
                    {/*  <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">
                          {t("Country Code")}
                        </label>
                        <Field
                          name={REGISTRATION_FORM.COUNTRY_CODE}
                          className="email-input"
                          placeholder={t(`Country code`)}
                           disabled={editable ? false : true}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.COUNTRY_CODE] &&
                            formik.errors[REGISTRATION_FORM.COUNTRY_CODE] && (
                              <p>
                                {t(
                                  `${
                                    formik.errors[
                                      REGISTRATION_FORM.COUNTRY_CODE
                                    ]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className="row row-wrap">

                    {userType === `${NUMBER_CONSTANTS.FIVE}` && <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label">{t("Website")}</label>
                        <Field
                          name={REGISTRATION_FORM.CAMPSITE}
                          className="email-input"
                          placeholder={t("Website")}
                          disabled={editable ? false : true}
                          min={3}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.CAMPSITE] &&
                            formik.errors[REGISTRATION_FORM.CAMPSITE] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.CAMPSITE]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div>}
                    {/*   <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("Country")}</label>
                        <Field
                          name={REGISTRATION_FORM.COUNTRY}
                          className="email-input"
                          placeholder={t(`Country code`)}
                           disabled={editable ? false : true}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.COUNTRY] &&
                            formik.errors[REGISTRATION_FORM.COUNTRY] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.COUNTRY]}`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div> */}
                    {/* <div className="col-md-6">
                      <div className="form-items">
                        <label className="form-label mandatory">{t("Nationality")}</label>
                        <Field
                          name={REGISTRATION_FORM.NATIONALITY}
                          className="email-input"
                          placeholder={t("Nationality")}
                           disabled={editable ? false : true}
                        />
                        <div className="errorMessage">
                          {formik.touched[REGISTRATION_FORM.NATIONALITY] &&
                            formik.errors[REGISTRATION_FORM.NATIONALITY] && (
                              <p>
                                {t(
                                  `${formik.errors[REGISTRATION_FORM.NATIONALITY]
                                  }`
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    </div> */}
                  </div>

                  {location.pathname === ROUTES.PROFILE ?

                    <div className="bi-buttons-wrap">
                      {/* <button
                        className="btn bi-btn btn-back"
                        onClick={() => onReset()}
                      >
                        Reset
                      </button> */}
                      {editable && <button
                        className="btn bi-btn btn-next"
                        type="submit"
                        onClick={() => {
                          formik.handleSubmit();
                        }}
                      >
                        Update
                      </button>}
                    </div>

                    : <div className="bi-buttons-wrap">
                      {!GetSessionStorageData(TOKENS.TEMPORARY_TOKEN) && <button
                        className="btn bi-btn btn-back"
                        onClick={() => onNavigate(0)}
                      >
                        Back
                      </button>}
                      <button
                        className="btn bi-btn btn-next"
                        type="submit"
                        onClick={() => {
                          console.log(formik.values, 'errors')
                          // formik.setFieldValue(REGISTRATION_FORM.EMAIL,GetSessionStorageData(STORAGE_KEYS.EMAIL) || "")
                          formik.handleSubmit();
                          validatePhoneNumber(
                            phoneNumber?.split("+").length > 1
                              ? phoneNumber
                              : "+" + phoneNumber
                          );
                        }}
                      >
                        Next
                      </button>
                    </div>}

                </div>
              );
            }}
          </Formik>
        </Card>
      </div>
    </div>
  );
};

export default BasicInformation;

// onNavigate(2);
